<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="acc-delivery-session-attendance-dialog">
		<readonly-access [readonly]="isReadonly()"></readonly-access>
		<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]='620'
			[rows]="attendees()"></grid-content>
	</div>

</dashboard-dialog-frame>